import { render, staticRenderFns } from "./c_tab_radio.vue?vue&type=template&id=0711b554&scoped=true"
import script from "./c_tab_radio.vue?vue&type=script&lang=js"
export * from "./c_tab_radio.vue?vue&type=script&lang=js"
import style0 from "./c_tab_radio.vue?vue&type=style&index=0&id=0711b554&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711b554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0711b554')) {
      api.createRecord('0711b554', component.options)
    } else {
      api.reload('0711b554', component.options)
    }
    module.hot.accept("./c_tab_radio.vue?vue&type=template&id=0711b554&scoped=true", function () {
      api.rerender('0711b554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_tab_radio.vue"
export default component.exports